import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Loader2 } from "lucide-react";
import clsx from "clsx";
const styles = {
    primary: "bg-brand-500 text-white hover:bg-brand-600 shadow-sm",
    ghost: "border border-slate-200 bg-white text-slate-700 hover:bg-slate-50",
    soft: "bg-slate-100 text-slate-700 hover:bg-slate-200",
    subtle: "text-slate-600 hover:text-slate-900 hover:bg-slate-100",
    danger: "bg-rose-500 text-white hover:bg-rose-600",
};
export const Button = forwardRef(function Button({ variant = "primary", leftIcon, rightIcon, className, children, loading, disabled, ...rest }, ref) {
    return (_jsxs("button", { ref: ref, disabled: disabled || loading, "aria-busy": loading || undefined, className: clsx("inline-flex items-center justify-center gap-2 rounded-lg px-3.5 py-2 text-sm font-medium transition disabled:opacity-50 disabled:cursor-not-allowed", styles[variant], className), ...rest, children: [loading ? _jsx(Loader2, { size: 14, className: "animate-spin" }) : leftIcon, children, rightIcon] }));
});
